var S = (e, a, s) => new Promise((t, r) => {
  var o = (n) => {
    try {
      i(s.next(n));
    } catch (_) {
      r(_);
    }
  }, l = (n) => {
    try {
      i(s.throw(n));
    } catch (_) {
      r(_);
    }
  }, i = (n) => n.done ? t(n.value) : Promise.resolve(n.value).then(o, l);
  i((s = s.apply(e, a)).next());
});
import { a as h, r as j, ar as F, q as B, o as J, y as ie, m as q, B as ne, u as ee, b as le, c as W, e as G, f as N, t as ce, l as ue } from "./define-element-XpjsV6s1.js";
import { i as y } from "./utils-CMsllPx8.js";
import { u as pe } from "./use-cart-D8NOb7eE.js";
import { u as me } from "./query-client-DZ5Df1It.js";
import { u as X } from "./use-config-1FCHS5th.js";
import { u as de } from "./use-states-T4YLdFAy.js";
import { u as fe } from "./use-user-CwEHAZOt.js";
import { U as ye } from "./data-D9rfxhB4.js";
import { L as he } from "./Loader-CeIJU_1y.js";
/* empty css                                                                */
import { _ as _e } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const te = "https://js.stripe.com/basil/stripe.js", H = "checkoutComplete", ae = "checkoutExpressComplete", ve = [
  "apple_pay",
  "google_pay",
  "card",
  "klarna",
  "us_bank_account"
], R = {
  layout: {
    type: "accordion",
    defaultCollapsed: !0
  },
  paymentMethodOrder: ve,
  defaultValues: {
    billingDetails: {
      email: null,
      name: null,
      address: {
        city: null,
        country: "US",
        line1: null,
        postal_code: null,
        state: null
      }
    }
  },
  wallets: {}
};
let E, I, U, z;
function K(e = !1) {
  var t, r;
  const a = new URL(
    window.location.origin + ((r = (t = window.OFFSET) == null ? void 0 : t.checkoutUrl) != null ? r : "/checkout")
  ), s = new URLSearchParams(window.location.search);
  return s.get("cantina") && a.searchParams.set("cantina", s.get("cantina")), a;
}
function je(e) {
  return e === "apple_pay" ? "Pay with Apple Pay" : e === "google_pay" ? "Pay with Google Pay" : e === "cashapp" ? "Pay with Cash App Pay" : e === "klarna" ? "Pay with Klarna" : e === "afterpay_clearpay" ? "Pay with Afterpay" : e === "affirm" ? "Pay with Affirm" : null;
}
function Y() {
  return S(this, arguments, function* (e = {}, a = {}) {
    const s = K();
    a.intent_type || (a.intent_type = "setup"), a.pathname = s.href;
    const t = yield j("stripe_elements", {
      method: "POST",
      body: JSON.stringify(a)
    });
    if (a.intent_type === "payment" && (t != null && t.error || !(t != null && t.clientSecret)))
      throw new Error((t == null ? void 0 : t.error) || "Unable to start payment");
    return {
      clientSecret: t.clientSecret,
      publishableKey: e.stripe_publishable_key,
      wallets: {
        // These are handled separately than add new payment methods
        // applePay: config.enable_apple_pay_payments ? "auto" : "never",
        // googlePay: config.enable_google_pay_payments ? "auto" : "never",
        applePay: "never",
        googlePay: "never"
      }
    };
  });
}
function Se(e, a = "stripe-payment-form", s) {
  const t = h(!1), r = h(!1), o = h(null), l = h(null), { config: i } = X(), { data: n } = fe();
  function _() {
    return S(this, null, function* () {
      var v, m, p, C, g;
      if (E || (E = window.Stripe(i.value.stripe_publishable_key)), !I) {
        const { clientSecret: u, wallets: w } = yield Y(i.value, {
          intent_type: "setup"
        });
        if (I = E.elements({
          clientSecret: u,
          appearance: we(e.value)
        }), (v = n.value) != null && v.email && y(R.defaultValues.billingDetails.email) && (R.defaultValues.billingDetails.email = n.value.email), (m = n.value) != null && m.first_name && ((p = n.value) != null && p.last_name) && y(R.defaultValues.billingDetails.name) && (R.defaultValues.billingDetails.name = `${n.value.first_name} ${n.value.last_name}`), (C = n.value) != null && C.addresses && ((g = n.value) == null ? void 0 : g.addresses.length) > 0) {
          const d = n.value.addresses[0];
          R.defaultValues.billingDetails.address = {
            city: d.city,
            country: d.country,
            line1: d.address,
            postal_code: d.zip,
            state: d.state
          };
        }
        R.wallets = w;
        const x = I.create("payment", R);
        x.on("change", (d) => {
          d.collapsed ? l.value = null : l.value = d.value.type;
        });
        const P = oe(e.value, a);
        x.mount(P), r.value = !0, ne(() => {
          const d = document.createElement("slot");
          d.name = a, s.value.appendChild(d);
        });
      }
    });
  }
  return B(
    [i, t],
    () => {
      y(i.value.stripe_publishable_key) || !t.value || _().catch((v) => {
        console.error("Failed to initialize Stripe payment element", v), F(v, { component: "use-stripe.ts:useStripeElementsPayment" }), o.value = "We're having trouble loading the payment form. Please refresh the page and try again.";
      });
    },
    { immediate: !0 }
  ), J(() => {
    Z(() => S(null, null, function* () {
      t.value = !0;
    }));
  }), ie(() => {
    I = null;
  }), { isStripeReady: r, stripeError: o, paymentType: l };
}
function Fe(e) {
  return S(this, null, function* () {
    var r;
    const { error: a } = yield I.submit();
    if (a)
      throw new Error((r = a.message) != null ? r : a);
    const s = K(), { error: t } = yield E.confirmSetup({
      elements: I,
      confirmParams: {
        return_url: s.href,
        payment_method_data: {
          billing_details: {
            email: e.email,
            name: `${e.first_name} ${e.last_name}`,
            phone: e.phone,
            address: {
              line1: e.address,
              line2: e.address_2,
              city: e.city,
              state: e.state,
              postal_code: e.zip,
              country: e.country || "US"
            }
          }
        }
      }
    });
    if (t)
      throw new Error(t.message);
  });
}
function Me(e, a, s) {
  return S(this, null, function* () {
    var i;
    const { clientSecret: t } = yield Y(a, {
      intent_type: "payment",
      capture_method: "manual",
      amount: s.total
    }), { error: r } = yield I.submit();
    if (r)
      throw new Error((i = r.message) != null ? i : r);
    const o = K();
    o.searchParams.set(H, "true");
    const { error: l } = yield E.confirmPayment({
      elements: I,
      clientSecret: t,
      confirmParams: {
        return_url: o.href,
        payment_method_data: {
          billing_details: {
            email: e.email,
            name: `${e.first_name} ${e.last_name}`,
            phone: e.phone,
            address: {
              line1: e.address,
              line2: e.address_2,
              city: e.city,
              state: e.state,
              postal_code: e.zip,
              country: e.country || "US"
            }
          }
        }
      }
    });
    if (l)
      throw new Error(l.message);
  });
}
function re(e, a) {
  return S(this, null, function* () {
    var o;
    const t = yield j("payment", {
      method: "POST",
      body: JSON.stringify(a ? { stripe_payment_method: e } : { stripe_setup_intent: e })
    });
    if (t != null && t.error)
      throw new Error(t.error);
    const r = String((o = t == null ? void 0 : t.id) != null ? o : t);
    return yield j(`cart/payment/${r}/select`), r;
  });
}
function se(e) {
  return S(this, null, function* () {
    try {
      const a = yield j(`stripe_payment_intent/${e}/cancel`, {
        method: "POST"
      });
      if (a != null && a.error)
        throw new Error(a.error);
    } catch (a) {
      F(a, { component: "use-stripe.ts:cancelStripePaymentIntent" });
    }
  });
}
function Le() {
  const e = me(), a = h(!1), s = h(null), t = h(!1), r = h(null), o = h(null), l = new URLSearchParams(window.location.search), i = l.get("setup_intent");
  l.get("setup_intent_client_secret");
  const n = l.get("payment_intent"), _ = l.get("redirect_status"), v = !!l.get(H), m = !!l.get(ae);
  if ((i || n) && _ === "succeeded") {
    a.value = v || m;
    const p = new URLSearchParams(window.location.search);
    p.delete("setup_intent"), p.delete("setup_intent_client_secret"), p.delete("payment_intent"), p.delete("payment_intent_client_secret"), p.delete("redirect_status"), p.delete(H), p.delete(ae);
    const C = window.location.pathname + (p.toString() ? `?${p}` : "") + window.location.hash;
    window.history.replaceState(null, "", C);
    const g = i != null ? i : n, u = !!n;
    o.value = n, re(g, u).then((w) => {
      e == null || e.invalidateQueries({ queryKey: ["payment"] }), s.value = w, (v || m) && (t.value = !0);
    }).catch((w) => {
      r.value = w.message, u && se(n);
    }).finally(() => {
      a.value = !1;
    });
  }
  return {
    wantsToComplete: a,
    newPaymentId: s,
    shouldCheckout: t,
    paymentIntentId: o,
    error: r
  };
}
function Ve(e, a) {
  if (!z)
    throw new Error("Wallet payment not available");
  const s = parseInt((a.total * 100).toString(), 10);
  return z.update({
    total: { label: "Total", amount: s }
  }), new Promise((t, r) => {
    const o = z, l = () => {
      var m, p;
      (m = o.off) == null || m.call(o, "paymentmethod", v), (p = o.off) == null || p.call(o, "cancel", _);
    }, i = (m) => {
      l(), t(m);
    }, n = (m) => {
      l(), r(m);
    }, _ = () => n(new Error("cancelled")), v = (m) => S(null, null, function* () {
      let p = !1;
      try {
        const { clientSecret: C } = yield Y(e, {
          intent_type: "payment",
          capture_method: "manual",
          confirm: !0,
          payment_method: m.paymentMethod.id,
          amount: a.total
        }), g = (P) => {
          var L, V;
          const d = new Error(
            (L = P == null ? void 0 : P.message) != null ? L : "There was a problem authorizing your payment. Please try again."
          ), M = (V = u == null ? void 0 : u.status) != null ? V : "unknown";
          return console.error("Wallet payment intent not authorized", { status: M, error: P }), F(d, {
            component: `use-stripe.ts:confirmWalletPayment (payment intent status: ${M})`
          }), d;
        };
        let { paymentIntent: u, error: w } = yield E.retrievePaymentIntent(C);
        if (w || !["requires_capture", "requires_action"].includes(u == null ? void 0 : u.status)) {
          m.complete("fail"), n(g(w));
          return;
        }
        if (m.complete("success"), p = !0, u.status === "requires_action" && ({ paymentIntent: u, error: w } = yield E.handleNextAction({
          clientSecret: C
        }), w || (u == null ? void 0 : u.status) !== "requires_capture")) {
          n(g(w));
          return;
        }
        let x;
        try {
          x = yield re(u.id, !0);
        } catch (P) {
          yield se(u.id), n(P);
          return;
        }
        i({ creditId: x, paymentIntentId: u.id });
      } catch (C) {
        p || m.complete("fail"), n(C);
      }
    });
    o.on("paymentmethod", v), o.on("cancel", _), o.show();
  });
}
function We() {
  const e = h(!1), a = h(!1), s = h(!1), t = h(!1), { config: r } = X();
  return B(
    [r, s],
    () => {
      if (y(r.value.stripe_publishable_key) || !s.value || t.value || !(r.value.enable_apple_pay_payments || r.value.enable_google_pay_payments)) return;
      t.value = !0, E || (E = window.Stripe(r.value.stripe_publishable_key));
      const l = E.paymentRequest({
        country: "US",
        currency: "usd",
        total: { label: "Check availability", amount: 100 },
        requestPayerName: !1,
        requestPayerEmail: !1,
        // Without this, Link (or a generic browser-saved card) can take
        // priority over the actual Apple Pay / Google Pay signal in the
        // canMakePayment() result below — e.g. reporting link:true while
        // applePay/googlePay both come back false even when correctly
        // configured and genuinely available. We only care about the two
        // wallet-specific booleans here, so exclude both other signals.
        disableWallets: ["link", "browserCard"]
      });
      l.canMakePayment().then((i) => {
        i && (z = l, r.value.enable_apple_pay_payments && (e.value = !!i.applePay), r.value.enable_google_pay_payments && (a.value = !!i.googlePay));
      }).catch((i) => {
        console.error("Error checking wallet availability", i), F(i, { component: "use-stripe.ts:useWalletAvailability" });
      });
    },
    { immediate: !0 }
  ), J(() => {
    Z(() => {
      s.value = !0;
    });
  }), { isApplePayAvailable: e, isGooglePayAvailable: a };
}
function Ne(e, a = "stripe-express-checkout", s) {
  let t = !1;
  const r = h(!1), o = h(!1), l = h(null), i = K(!0), {
    cart: n,
    isLoadingCart: _,
    fetchCart: v,
    fetchShippingOptionsByState: m,
    shippingOptions: p,
    selectShippingMethodForCart: C
  } = pe(), { config: g } = X(), { data: u } = de(), w = q(() => ye[2].filter((f) => u.value.includes(f[1]))), x = q(() => _.value ? 0 : parseInt((n.value.total * 100).toString(), 10)), P = q(() => {
    var O, k;
    const f = n.value.items.map((c) => ({
      name: `${c.quantity} x ${c.name}`,
      amount: parseInt((c.price * 100).toString(), 10) * parseInt(c.quantity, 10)
    }));
    if (y(n.value.discount) || f.push({
      name: "Discount",
      amount: parseInt((n.value.discount * 100).toString(), 10)
    }), y(n.value.shipping) || f.push({
      name: "Shipping",
      amount: parseInt((n.value.shipping * 100).toString(), 10)
    }), y(n.value.ca_redemption_value) || f.push({
      name: "California Redemption Value (CRV)",
      amount: parseInt((n.value.ca_redemption_value * 100).toString(), 10)
    }), !y(n.value.tax) && g.value.enable_co_retail_delivery_fee && ((k = (O = n.value.shipment) == null ? void 0 : O.address) == null ? void 0 : k.state) === "CO") {
      const c = parseInt(
        (n.value.co_retail_delivery_fee * 100).toString(),
        10
      ), A = parseInt((n.value.tax * 100).toString(), 10) - c;
      f.push({
        name: "Colorado Retail Delivery Fee",
        amount: c
      }), f.push({
        name: "Tax",
        amount: A
      });
    } else y(n.value.tax) || f.push({
      name: "Tax",
      amount: parseInt((n.value.tax * 100).toString(), 10)
    });
    return f;
  }), d = q(() => ({
    mode: "setup",
    currency: "usd"
  })), M = q(() => ({
    emailRequired: !0,
    billingAddressRequired: !0,
    shippingAddressRequired: !0,
    lineItems: P.value
  }));
  J(() => {
    o.value = !0;
  }), B(
    [g, x, r, o],
    () => {
      !o.value || y(g.value.stripe_publishable_key) || y(x.value) || (t || (t = !0, L()), U != null && U.update(d.value));
    },
    { immediate: !0 }
  );
  function L() {
    Z(() => S(null, null, function* () {
      try {
        yield V();
      } catch (f) {
        console.error("Failed to initialize Stripe express checkout", f), F(f, { component: "use-stripe.ts:useStripeExpressCheckout" }), t = !1;
      }
    }));
  }
  function V() {
    return S(this, null, function* () {
      const f = oe(e.value, a), O = window.Stripe(
        g.value.stripe_publishable_key
      );
      U = O.elements(d.value);
      const k = U.create(
        "expressCheckout",
        M.value
      );
      k.on("ready", (c) => {
        y(c.availablePaymentMethods) || (l.value = c.availablePaymentMethods);
      }), k.on("shippingaddresschange", (c) => S(null, null, function* () {
        if (!w.value.some((b) => b[1] === c.address.state)) {
          c.reject({
            message: "We cannot ship to this address."
          });
          return;
        }
        yield m(c.address.state), yield v();
        const T = Object.values(p.value).map(
          (b) => ({
            id: b.id,
            displayName: b.name,
            amount: parseInt((b.rate * 100).toString(), 10)
          })
        );
        if (!y(n.value.config.ship_method_id)) {
          for (const b of T)
            if (b.id === n.value.config.ship_method_id) {
              T.splice(T.indexOf(b), 1), T.unshift(b);
              break;
            }
        }
        c.resolve({
          shippingRates: T,
          lineItems: P.value
        });
      })), k.on("shippingratechange", (c) => S(null, null, function* () {
        yield C(c.shippingRate.id), yield v(), c.resolve({
          lineItems: P.value
        });
      })), k.on("cancel", () => {
      }), k.on("confirm", (c) => S(null, null, function* () {
        const { error: A } = yield U.submit();
        if (A) {
          console.error(A);
          return;
        }
        const b = (yield j("stripe_elements", {
          method: "POST",
          body: JSON.stringify({
            pathname: i.href
          })
        })).clientSecret;
        if (y(b))
          console.error("Client secret is empty!");
        else {
          const { error: D } = yield O.confirmSetup({
            elements: U,
            clientSecret: b,
            confirmParams: {
              return_url: i.href
            }
          });
          D && console.error(D);
        }
      })), k.mount(f), r.value = !0, ne(() => {
        const c = document.createElement("slot");
        c.name = a, s.value.appendChild(c);
      });
    });
  }
  return { isStripeReady: r, availablePaymentMethods: l };
}
function oe(e, a = "stripe-payment-form") {
  const t = e.getRootNode().host, r = t.querySelector(`[slot="${a}"]`);
  if (r)
    return r.firstChild;
  {
    const o = document.createElement("div");
    o.slot = a, t.appendChild(o);
    const l = document.createElement("div");
    return o.appendChild(l), l;
  }
}
let $ = [];
function Z(e) {
  if ($.length > 0) {
    $.push(e);
    return;
  }
  if (document.querySelector(`script[src='${te}']`)) {
    e();
    return;
  }
  $.push(e);
  const s = document.createElement("script");
  s.addEventListener("load", function() {
    $.forEach(e), $ = [];
  }), s.src = te, document.head.appendChild(s);
}
function we(e) {
  const a = {}, s = {
    colorPrimary: "--offset-primary",
    colorText: "--offset-body-color",
    colorTextSecondary: "--offset-secondary",
    colorDanger: "--offset-danger",
    fontFamily: "--offset-font-family-base",
    borderRadius: "--offset-border-radius"
  }, t = getComputedStyle(e);
  return Object.keys(s).forEach((r) => {
    const o = t.getPropertyValue(
      s[r]
    );
    y(o) || (a[r] = o.trim());
  }), { variables: a };
}
const ge = {
  class: "offset-stripe-payment-form",
  ref: "container"
}, Pe = ["textContent"], Q = "stripe-payment-form", be = {
  __name: "StripePaymentForm",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    saveText: {
      type: String,
      default: "Pay now"
    }
  },
  emits: ["save", "paymentTypeChanged"],
  setup(e, { emit: a }) {
    const s = a, t = e, r = ee("container"), o = ee(Q), { isStripeReady: l, stripeError: i, paymentType: n } = Se(
      r,
      Q,
      o
    );
    return B(n, (_) => {
      s("paymentTypeChanged", _);
    }), J(() => {
      le(r.value, t.inheritStyle);
    }), (_, v) => (W(), G("form", ge, [
      N(y)(N(i)) ? N(l) ? (W(), G("div", {
        key: 1,
        ref: Q
      })) : (W(), ue(he, { key: 2 })) : (W(), G("div", {
        key: 0,
        textContent: ce(N(i)),
        class: "error",
        role: "alert"
      }, null, 8, Pe))
    ], 512));
  }
}, ze = /* @__PURE__ */ _e(be, [["__scopeId", "data-v-a9e14e2e"]]);
export {
  ze as S,
  Le as a,
  se as b,
  Fe as c,
  Ve as d,
  Me as e,
  We as f,
  je as p,
  Ne as u
};
